import { SxProps, Theme } from "@mui/material";
import Grid from "@mui/material/Grid";
import CustomBtnFilled from "../../../../atoms/form-molecules/CustomBtnFilled";

type Props = {
  handleClose: () => void;
  submitLabel?: string;
  sx?: SxProps<Theme>;
  handleSubmitBtnClick?: (() => Promise<void>) | (() => void);
  cancelLabel?: string;
  isSubmitDisabled?: boolean;
  isCancelDisabled?: boolean;
};

const DeclineSubmitBtns = ({
  handleClose,
  submitLabel = "submit",
  sx,
  handleSubmitBtnClick,
  cancelLabel,
  isSubmitDisabled = false,
  isCancelDisabled = false
}: Props) => {
  return (
    <Grid
      sx={{
        padding: "5px",
        display: "flex",
        justifyContent: "flex-end",
        gap: "1rem",
        ...sx
      }}
      item
      xs={12}
    >
      <CustomBtnFilled
        label={cancelLabel || "cancel"}
        variant="outlined"
        onClick={handleClose}
        disabled={isCancelDisabled}
      />
      {handleSubmitBtnClick ?
        <CustomBtnFilled
          label={submitLabel}
          variant="contained"
          onClick={handleSubmitBtnClick}
          disabled={isSubmitDisabled || isCancelDisabled}
        />
        : <CustomBtnFilled
          label={submitLabel}
          variant="contained"
          buttonType="submit"
          disabled={isSubmitDisabled || isCancelDisabled}
        />
      }
    </Grid>
  );
};

export default DeclineSubmitBtns;